import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { size, text, tone, weight } from './Text.css';

type Size = keyof typeof size;
type Tone = keyof typeof tone;
type Weight = keyof typeof weight;

export type TextProps = ComponentPropsWithoutRef<'span'> & {
  size?: Size;
  tone?: Tone;
  weight?: Weight;
  as?: ElementType;
};

export function Text({
  size: s = 'md',
  tone: t = 'default',
  weight: w = 'regular',
  as,
  className,
  ...rest
}: TextProps) {
  const Element = as ?? 'span';
  const classes = [text, size[s], tone[t], weight[w], className].filter(Boolean).join(' ');
  return <Element className={classes} {...rest} />;
}
